import { useDatasetRow } from "../datasets";

export const useDatasetInputVariables = (datasetRowId: number | null) => {
  const { data, isFetching, error, refetch } = useDatasetRow(datasetRowId);

  if (!data || !data.dataset_row) {
    return { isFetching, error, refetch };
  }

  const variables = data.dataset_row.variables;

  return { data: variables, isFetching, error, refetch };
};
